/*
 * @Author: MingLu
 * @Date: 2020-12-25 11:38:08
 * @LastEditTime: 2023-03-01 10:03:56
 * @LastEditors: Duanjiaojiao
 * @Description:
 * @FilePath: /BM-Main/src/apiData/common.js
 */
import apiNew from '@/conf/apiNew'
import httpClient from '@/utils/http'

// 判断是否为 手机/平板 分类
export const isPhoneOrPad = (cateId = '101') => {
  return cateId == '101' || cateId == '119'
}

// 获取阿波罗配置数据
export const getFeApolloInfoAjax = (params) => {
  return httpClient.get(apiNew.getFeApolloInfo, params).then((data) => data)
}
// 获取门店回收阿波罗配置数据
export const getFeStoreApolloInfoAjax = (params) => {
  return httpClient.get(apiNew.getFeStoreApolloInfo, params).then((data) => data)
}

// 生成朋友圈海报
export const getPosterImgAjax = (params) => {
  return httpClient.get(apiNew.getPosterImg, params).then((data) => data)
}

// 生成小程序码
export const getMiniCodeAjax = (params) => {
  return httpClient
    .get(apiNew.getMiniCode, {
      source: '103',
      width: '200',
      height: '200',
      autoColor: 'false',
      lineColor: {
        r: '0',
        g: '0',
        b: '0'
      },
      page: 'pages/webview/bridge',
      params: {
        ...params,
        shareCode: 'true'
      }
    })
    .then((data) => data)
}

// 获取带有服务器当前时间戳的快递时间
export const getReserveTimesV2Ajax = (params) => {
  return httpClient.get(apiNew.getReserveTimesV2, params).then((res) => res)
}

// 获取自行寄件的收件地址
export const getDefaultWarehouseAjax = (params) => {
  return httpClient.get(apiNew.getDefaultWarehouse, params).then((res) => res)
}
// 获取用户地址列表接口
export const getAllAddressAjax = (params) => {
  return httpClient.get(apiNew.getAllAddress, params).then((res) => res)
}
// 获取用户默认地址接口
export const getDefaultAddressAjax = (params) => {
  return httpClient.get(apiNew.getDefaultAddress, params).then((res) => res)
}
// 更新用户地址接口
export const updateAddressAjax = (params) => {
  return httpClient.post(apiNew.updateAddress, params).then((res) => res)
}
// 增加用户地址接口
export const addAddressAjax = (params) => {
  return httpClient.get(apiNew.addAddress, params).then((res) => res)
}

// 通用查询用户信息接口
export const getUserInfoByUidAjax = (params) => {
  return httpClient.get(apiNew.getUserInfoByUid, params).then((res) => res)
}

// 通用鹰眼 AB 测接口
export const getCommonABTestAjax = (params) => {
  const { testId, isConsignServer } = params || {}
  if (isConsignServer) {
    return httpClient.get(apiNew.getCommonABTestConsignment, { testId }).then((res) => {
      const { sceneGroupName = 'A' } = res || {}
      return sceneGroupName
    })
  }
  return httpClient.get(apiNew.getCommonABTest, { testId }).then((res) => res)
}

// 通用鹰眼批量 AB 测接口
export const getMultiABTestAjax = (params) => {
  return httpClient.get(apiNew.getMultiABTest, params).then((res) => res)
}

// 获取城市信息
export const getLocalCityAjax = () => {
  return httpClient.get(apiNew.getLocalCity).then((res) => res)
}

// 通用下单接口
export const commonCreateOrderAjax = (params, allData) => {
  return httpClient.post(apiNew.commonCreateOrder, params, { allData }).then((res) => res)
}

// 保存地址
export const saveUserAddressAjax = (params) => {
  return httpClient.post(apiNew.saveUserAddress, params).then((res) => res)
}

// 暗文手机号 转明文 例如：159****2222 转 15922222222
export const getUserRealPhoneAjax = (params) => {
  return httpClient.post(apiNew.getUserRealPhone, params).then((res) => res)
}
